import axios from "axios";
const api = axios.create({
  baseURL: "https://rest.carcenterpneusbrasil.com:8199/rest/", // produção ambiemte https
  //baseURL: "https://rest.carcenterpneusbrasil.com:8399/rest/", // produção ambiemte https - compilação
  //baseURL: "https://rest.carcenterpneusbrasil.com:8789/rest/", // produção ambiemte https - compilação
  //baseURL: 'https://198.0.1.201:8199/rest/', // produção ambiemte https
  //baseURL: 'https://198.0.1.201:8897/rest/', // produção ambiemte https - Teste PTESTE
  headers: {
    "Content-type": "application/json",
    Accept: "application/vnd.github+json",
    // 'Authorization': "Basic YWRtaW46QE5lbHNvbjEx",
  },
});

export default api;
